export default __webpack_public_path__ + "static/media/attach-money.5aefeac2.svg";